export enum WorkHoursMonthSummaryEnum {
  OK = 'green',
  EXCEED = 'red',
  BELOW = 'yellow',
  EMPTY = 'gray',
  SUMMARY = 'gray',
}
